import { ReactNode } from 'react';
import './style.scss';

export default function Loading({
  isLoading,
  text = 'Loading...',
  className = undefined,
  style,
  ...props
}: {
  isLoading: boolean;
  text?: string;
  className?: string;
  style?: any;
  children?: ReactNode;
}) {
  return (
    <div className={'loading-overlay ' + className} style={style}>
      {props.children}
      {isLoading && (
        <div className="loading-spinner d-flex align-items-center justify-content-center ">
          <div className="spinner-border" role="status"></div>
          {text && <span className="ms-2">{text}</span>}
        </div>
      )}
    </div>
  );
}
